import { REGION_GUIDS } from '@/shared/constants';
import { selectColumn } from '@/shared/handsontable/mixins/featureSelectableRows';
import { placeholderColumn } from '@/shared/handsontable/mixins/tableBase';
import { availableFeatures } from '@/shared/storeDynamicFeatures';

import {
  amaCode,
  cadastralCommunity,
  catchCropVariant,
  comment,
  companyId,
  crop,
  customer,
  fieldGroupNumber,
  fieldNumber,
  gwArea,
  kindOfUse,
  mbi,
  nameWithStatus,
  ndvi,
  owner,
  plots,
  preCrop,
  rightOfUse,
  sharedFieldInfo,
  size,
  status,
  variety,
  waterProtectionZone,
} from './columns';

export const tableFields = [
  {
    ...selectColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
  {
    ...companyId,
    lockedVisibility: true,
    lockedPosition: true,
    requiredFeatures: (store) => store.state.auth.currentCompanies.length > 1,
  },
  {
    ...customer,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length > 0,
  },
  {
    ...customer,
    hiddenPerDefault: true,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length === 0,
  },
  {
    ...fieldGroupNumber,
    lockedVisibility: true,
    lockedPosition: true,
    sortOrder: 'asc',
  },
  {
    ...fieldNumber,
    hiddenPerDefault: true,
    lockedPosition: true,
  },
  {
    ...nameWithStatus,
    lockedVisibility: true,
    lockedPosition: true,
  },
  size,
  crop,
  variety,
  {
    ...sharedFieldInfo,
    requiredFeatures: (store, context) =>
      context.sharedFieldsByFieldId != null && Object.keys(context.sharedFieldsByFieldId).length > 0,
  },
  preCrop,
  {
    ...kindOfUse,
    hiddenPerDefault: true,
  },
  comment,
  {
    ...waterProtectionZone,
    hiddenPerDefault: true,
  },
  {
    ...cadastralCommunity,
    hiddenPerDefault: true,
  },
  {
    ...plots,
    hiddenPerDefault: true,
  },
  {
    ...owner,
    hiddenPerDefault: true,
  },
  {
    ...rightOfUse,
    hiddenPerDefault: true,
  },
  {
    ...status,
    lockedVisibility: true,
  },
  {
    ...ndvi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...mbi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...placeholderColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
];

export const tableFieldsAt = [
  {
    ...selectColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
  {
    ...companyId,
    lockedVisibility: true,
    lockedPosition: true,
    requiredFeatures: (store) => store.state.auth.currentCompanies.length > 1,
  },
  {
    ...customer,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length > 0,
  },
  {
    ...customer,
    hiddenPerDefault: true,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length === 0,
  },
  {
    ...fieldGroupNumber,
    lockedVisibility: true,
    lockedPosition: true,
    sortOrder: 'asc',
  },
  {
    ...fieldNumber,
    lockedPosition: true,
  },
  {
    ...nameWithStatus,
    lockedVisibility: true,
    lockedPosition: true,
  },
  size,
  crop,
  variety,
  {
    ...sharedFieldInfo,
    requiredFeatures: (store, context) =>
      context.sharedFieldsByFieldId != null && Object.keys(context.sharedFieldsByFieldId).length > 0,
  },
  preCrop,
  {
    ...catchCropVariant,
    hiddenPerDefault: true,
  },
  kindOfUse,
  comment,
  {
    ...gwArea,
    lockedVisibility: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_GROUNDWATER_PROTECTION),
  },
  {
    ...waterProtectionZone,
    hiddenPerDefault: true,
  },
  {
    ...amaCode,
    hiddenPerDefault: true,
  },
  {
    ...cadastralCommunity,
    hiddenPerDefault: true,
  },
  {
    ...plots,
    hiddenPerDefault: true,
  },
  {
    ...owner,
    hiddenPerDefault: true,
  },
  {
    ...rightOfUse,
    hiddenPerDefault: true,
  },
  {
    ...status,
    lockedVisibility: true,
  },
  {
    ...ndvi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...mbi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...placeholderColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
];

export const tableFieldsDe = [
  {
    ...selectColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
  {
    ...companyId,
    lockedVisibility: true,
    lockedPosition: true,
    requiredFeatures: (store) => store.state.auth.currentCompanies.length > 1,
  },
  {
    ...customer,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length > 0,
  },
  {
    ...customer,
    hiddenPerDefault: true,
    lockedPosition: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_CUSTOMERS) &&
      Object.values(store.state.customers.data).length === 0,
  },
  {
    ...fieldGroupNumber,
    lockedVisibility: true,
    lockedPosition: true,
    sortOrder: 'asc',
  },
  {
    ...fieldNumber,
    lockedPosition: true,
  },
  {
    ...nameWithStatus,
    lockedVisibility: true,
    lockedPosition: true,
  },
  size,
  crop,
  variety,
  {
    ...sharedFieldInfo,
    requiredFeatures: (store, context) =>
      context.sharedFieldsByFieldId != null && Object.keys(context.sharedFieldsByFieldId).length > 0,
  },
  preCrop,
  {
    ...kindOfUse,
    hiddenPerDefault: true,
  },
  comment,
  {
    ...waterProtectionZone,
    hiddenPerDefault: true,
  },
  {
    ...cadastralCommunity,
    hiddenPerDefault: true,
  },
  {
    ...plots,
    hiddenPerDefault: true,
  },
  {
    ...owner,
    hiddenPerDefault: true,
  },
  {
    ...rightOfUse,
    hiddenPerDefault: true,
  },
  {
    ...status,
    lockedVisibility: true,
  },
  {
    ...ndvi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...mbi,
    hiddenPerDefault: true,
    requiredFeatures: (store) =>
      store.getters.currentCompaniesHaveFeatureVisible(availableFeatures.FEATURE_FIELDS_NDVI_MEAN),
  },
  {
    ...placeholderColumn,
    hiddenInPageSettings: true,
    lockedVisibility: true,
    lockedPosition: true,
  },
];

export default {
  international: tableFields,
  [REGION_GUIDS.AT]: tableFieldsAt,
  [REGION_GUIDS.DE]: tableFieldsDe,
};
